import { Auth } from "@/interfaces/domain/User";
import { api } from "@/services/api";

import { storeApiToken } from "./token";
import { updateUserExpoToken } from "./user";

export type LoginParams = {
  email: string;
  password: string;
  notificationToken?: string;
};

export async function loginRequest(params: LoginParams) {
  const { data } = await api.post<Auth>("/login/cliente", {
    email: params.email,
    senha: params.password,
  });
  await storeApiToken(data.token);
  if (params.notificationToken) {
    await updateUserExpoToken(data.usuario._id, params.notificationToken);
  }
  return data;
}
